import * as React from 'react';
import { connect } from 'react-redux';
import { SubmissionError } from 'redux-form';
import {
  CharityRegisterForm,
  validateRegistrationValues,
} from './CharityRegisterForm';
import { auth } from './../../../firebase';

class CharityRegisterComponent extends React.Component<any> {
  render() {
    return (
      <div className="section-default">
        <div className="container">
          <CharityRegisterForm onSubmit={this.handleSubmit} />
        </div>
      </div>
    );
  }

  handleSubmit = values => {
    const errors = validateRegistrationValues(values);
    if (Object.keys(errors).length > 0) {
      throw new SubmissionError(errors);
    }

    const { email, password, fullName } = values;
    const { history } = this.props;

    auth.createUserWithEmailAndPassword(email, password).then(
      () => {
        const currentUser = auth.currentUser;
        currentUser
          .updateProfile({ displayName: fullName, photoURL: null })
          .catch(() => null) // ignore any profile update errors
          .then(() => {
            if (!!history) {
              history.push('/onboarding');
            }
          });
      },
      error => {
        const errorCode = error.code;
        const errorMessage = error.message;
        if (errorCode === 'auth/weak-password') {
          alert(
            'Please choose a stronger password. Passwords should be 6 characters or more.'
          );
        } else {
          alert(errorMessage);
        }
      }
    );
  };
}

const CharityRegister = connect()(CharityRegisterComponent);

export { CharityRegister };
